import { render } from "./CollapsibleTags.vue?vue&type=template&id=3c4bf359&scoped=true"
import script from "./CollapsibleTags.vue?vue&type=script&lang=js"
export * from "./CollapsibleTags.vue?vue&type=script&lang=js"

import "./CollapsibleTags.vue?vue&type=style&index=0&id=3c4bf359&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4bf359"]])

export default __exports__